import { BUSINESS_HOURS_CHANGE } from '../types'

export default function doBusinessHoursChange(days) {
  return {
    type: BUSINESS_HOURS_CHANGE,
    days,
  }
}
